import { defineStore } from "pinia";
import { ref } from "vue";
import { CreateTaskFromSuggestionRequest, JackBurtonApi, TaskSuggestion } from "@/services/api/sdk";
import { ApiConfiguration } from "@/services/api/api-configuration.ts";

export const useTaskSuggestionStore = defineStore('task-suggestion', () => {
    const suggestions = ref<TaskSuggestion[]>([]);

    function $reset() {
        suggestions.value = [];
    }

    async function createTaskFromSuggestion(taskSuggestionId: number, createTaskFromSuggestionRequest: CreateTaskFromSuggestionRequest): Promise<void> {
        const api = new JackBurtonApi(ApiConfiguration);
        await api.createTaskFromSuggestion({
            taskSuggestionId,
            createTaskFromSuggestionRequest
        });
    }

    async function removeTaskSuggestion(suggestion: TaskSuggestion): Promise<void> {
        const api = new JackBurtonApi(ApiConfiguration);
        await api.rejectTaskSuggestion({
            taskSuggestionId: suggestion.id!,
        });
        suggestions.value = suggestions.value.filter((_suggestion) => _suggestion.id !== suggestion.id);
    }


    function addSuggestion(suggestion: TaskSuggestion) {
        suggestions.value.push(suggestion);
    }

    return {
        $reset,
        addSuggestion,
        suggestions,
        createTaskFromSuggestion,
        removeTaskSuggestion,
    }
});